/* Coffee Cruise — krepšelio pasiūlymas pridėti kavą.
   Liquid atiduoda visus tinkamus kandidatus (tas pats formatas, tas pats
   prenumeratos planas, dar ne krepšelyje); čia parodomi du atsitiktiniai,
   kad pasiūlymas nebūtų visada tas pats. cart.js perpiešus suvestinę
   (pakeitus kiekį) — atrenkama iš naujo. */
(function () {
  "use strict";

  function pick() {
    var ul = document.querySelector(".pren-ups-l");
    if (!ul || ul.getAttribute("data-picked")) return;
    ul.setAttribute("data-picked", "1");
    var li = Array.prototype.slice.call(ul.children);
    for (var i = li.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = li[i]; li[i] = li[j]; li[j] = t;
    }
    li.forEach(function (x, n) { x.hidden = n >= 2; });
  }
  pick();

  var footer = document.getElementById("main-cart-footer");
  if (footer && window.MutationObserver) {
    new MutationObserver(pick).observe(footer, { childList: true, subtree: true });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-pren-ups]") : null;
    if (!b || b.disabled) return;
    b.disabled = true;
    b.textContent = "Dedama…";
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{
        id: parseInt(b.getAttribute("data-vid"), 10),
        quantity: 1,
        selling_plan: parseInt(b.getAttribute("data-sp"), 10)
      }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("cart/add " + r.status); window.location.reload(); })
      .catch(function (err) {
        console.error("[pren-cart]", err);
        b.disabled = false;
        b.textContent = "Bandyk dar kartą";
      });
  });
})();

/* ---------- dovana nuo X € ----------
   Liquid pasako: varianto id, slenkstį, sumą be dovanos, ar dovana jau
   krepšelyje, jos kainą ir nuolaidos kodą. Čia suvienodinama būsena:
   - suma ≥ slenksčio, dovanos nėra  → įdėti + pritaikyti kodą
   - dovana yra, bet kainuoja        → pritaikyti kodą
   - suma < slenksčio, dovana yra     → išimti
   Saugiklis: jei po kodo dovana vis tiek kainuoja (nuolaida neveikia),
   ji išimama ir šią sesiją nebebandoma — pirkėjas niekada nemoka už dovaną. */
(function () {
  "use strict";
  var KEY = "pren_gift_off";
  var busy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  function off() { try { return sessionStorage.getItem(KEY) === "1"; } catch (e) { return false; } }
  function setOff() { try { sessionStorage.setItem(KEY, "1"); } catch (e) {} }
  function post(url, body) {
    return fetch(root + url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + " " + r.status); return r.json(); });
  }
  function getCart() { return fetch(root + "cart.js").then(function (r) { return r.json(); }); }
  function giftLine(cart, vid) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === vid) return cart.items[i];
    return null;
  }
  /* kodas pridedamas prie jau esamų, ne vietoj jų */
  function applyCode(cart, code) {
    if (!code) return Promise.resolve(cart);
    var have = (cart.discount_codes || []).map(function (d) { return d.code; });
    if (have.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) return Promise.resolve(cart);
    return post("cart/update.js", { discount: have.concat([code]).join(",") }).then(getCart);
  }
  function ensureFree(cart, vid, code) {
    var line = giftLine(cart, vid);
    if (!line || line.final_line_price === 0) return Promise.resolve(false);
    return applyCode(cart, code).then(function (c2) {
      var l2 = giftLine(c2, vid);
      if (l2 && l2.final_line_price > 0) {
        console.warn("[pren-cart] dovana nėra nemokama — nuolaida neveikia, dovana išimama");
        setOff();
        return post("cart/change.js", { id: l2.key, quantity: 0 }).then(function () { return true; });
      }
      return true;
    });
  }
  function sync() {
    var el = document.querySelector("[data-pren-gift]");
    if (!el || busy || off()) return;
    var vid = parseInt(el.getAttribute("data-vid"), 10);
    var min = parseInt(el.getAttribute("data-min"), 10);
    var sub = parseInt(el.getAttribute("data-sub"), 10);
    var inCart = el.getAttribute("data-in") === "true";
    var price = parseInt(el.getAttribute("data-price") || "0", 10);
    var code = el.getAttribute("data-code") || "";
    var want = sub >= min;
    var job = null;
    if (want && !inCart) {
      job = post("cart/add.js", { items: [{ id: vid, quantity: 1, properties: { "Dovana": "Pirmai siuntai", "_pren_gift": "1" } }] })
        .then(getCart).then(function (c) { return ensureFree(c, vid, code); }).then(function () { return true; });
    } else if (want && inCart && price > 0) {
      job = getCart().then(function (c) { return ensureFree(c, vid, code); });
    } else if (!want && inCart) {
      job = getCart().then(function (c) {
        var line = giftLine(c, vid);
        return line ? post("cart/change.js", { id: line.key, quantity: 0 }).then(function () { return true; }) : false;
      });
    }
    if (!job) return;
    busy = true;
    job.then(function (changed) { if (changed) window.location.reload(); else busy = false; })
      .catch(function (err) { console.error("[pren-cart]", err); busy = false; });
  }
  sync();
  var footer = document.getElementById("main-cart-footer");
  if (footer && window.MutationObserver) new MutationObserver(function () { setTimeout(sync, 50); }).observe(footer, { childList: true, subtree: true });
})();
/* Telefone: lipnus "Atsiskaityti", kol pagrindinis mygtukas nesimato.
   Elementas perpiešiamas kartu su suvestine, todėl ieškomas kiekvieną kartą. */
(function () {
  var mq = window.matchMedia("(max-width: 749px)");
  function upd() {
    var s = document.querySelector("[data-pren-cart-sticky]");
    var co = document.getElementById("checkout");
    if (!s) return;
    if (!mq.matches || !co) { s.hidden = true; return; }
    var r = co.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    s.hidden = r.top < vh && r.bottom > 0;
  }
  var t = 0;
  function q() { if (!t) t = setTimeout(function () { t = 0; upd(); }, 80); }
  window.addEventListener("scroll", q, { passive: true });
  window.addEventListener("resize", q);
  if (window.MutationObserver) {
    var f = document.getElementById("main-cart-footer");
    if (f) new MutationObserver(q).observe(f, { childList: true, subtree: true });
  }
  upd();
})();

/* Dovanos atsisakymas / grąžinimas: krepšelio atributas _pren_gift_off,
   po to pren-tiers.js išima arba įdeda dovaną ir puslapis perkraunamas. */
document.addEventListener("click", function (e) {
  var b = e.target.closest ? e.target.closest("[data-pren-gift-off],[data-pren-gift-on]") : null;
  if (!b || b.disabled) return;
  b.disabled = true;
  var vid = b.getAttribute("data-pren-gift-off") || b.getAttribute("data-pren-gift-on");
  var turnOff = b.hasAttribute("data-pren-gift-off");
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var json = { "Content-Type": "application/json", "Accept": "application/json" };
  fetch(root + "cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
    var cur = String((cart.attributes && cart.attributes._pren_gift_off) || "").split(",").filter(Boolean);
    cur = cur.filter(function (v) { return v !== vid; });
    if (turnOff) cur.push(vid);
    var keys = [];
    if (turnOff) (cart.items || []).forEach(function (it) { if (String(it.variant_id) === vid) keys.push(it.key); });
    var chain = fetch(root + "cart/update.js", { method: "POST", headers: json, body: JSON.stringify({ attributes: { _pren_gift_off: cur.join(",") } }) });
    keys.forEach(function (k) {
      chain = chain.then(function () { return fetch(root + "cart/change.js", { method: "POST", headers: json, body: JSON.stringify({ id: k, quantity: 0 }) }); });
    });
    return chain.then(function () {
      if (!turnOff && window.prenTiersCheck) { window.prenTiersCheck(); setTimeout(function () { location.reload(); }, 3000); }
      else location.reload();
    });
  }).catch(function () { b.disabled = false; });
});

/* Krepšelis — paskutinis patikrinimas: patvirtinimo juosta atėjus iš konfigūratoriaus
   ir suma atsiskaitymo mygtuke (sinchronizuojama su suvestinės „Už siuntą“). */
(function () {
  var params = new URLSearchParams(location.search);
  /* žymė išlieka, jei pakopų skriptas perkrauna krepšelį (dovanos) */
  var KEY = "pren_added_at", now = Date.now(), at = 0;
  try { if (params.has("added")) sessionStorage.setItem(KEY, String(now)); at = parseInt(sessionStorage.getItem(KEY) || "0", 10); } catch (e) { at = params.has("added") ? now : 0; }
  if (at && now - at < 120000) {
    var items = document.querySelector("#main-cart-items");
    if (items && document.querySelector(".cart-item")) {
      var bar = document.createElement("div");
      bar.className = "pren-cart-added";
      bar.setAttribute("role", "status");
      bar.innerHTML = '<span class="pren-cart-added-ico" aria-hidden="true">✓</span>' +
        '<span><b>Prenumerata įdėta.</b> Patikrink kavas, kiekį ir dažnumą – tada spausk „Apmokėti“.</span>';
      items.parentNode.insertBefore(bar, items);
    }
  }
  if (params.has("added")) {
    params.delete("added");
    var q = params.toString();
    history.replaceState(null, "", location.pathname + (q ? "?" + q : "") + location.hash);
  }
  function syncBtn() {
    var t = document.querySelector(".pren-sum .is-total dd");
    var b = document.querySelector("#checkout.cart__checkout-button");
    if (!b || !t) return;
    var label = "Apmokėti · " + t.textContent.trim();
    if (b.textContent.trim() !== label) b.textContent = label;
    var sb = document.querySelector(".pren-cart-sticky-b");
    if (sb && sb.textContent.trim() !== "Apmokėti") sb.textContent = "Apmokėti";
  }
  syncBtn();
  var foot = document.getElementById("main-cart-footer");
  if (foot && window.MutationObserver) new MutationObserver(syncBtn).observe(foot, { childList: true, subtree: true, characterData: true });
})();

/* „+1 kg → −40%“: vienu paspaudimu įdeda trūkstamą kiekį (tas pats planas), tada sutvarkomos pakopos */
document.addEventListener("click", function (e) {
  var b = e.target.closest ? e.target.closest("[data-pren-upsell]") : null;
  if (!b || b.disabled) return;
  b.disabled = true;
  b.classList.add("is-busy");
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var line = { id: parseInt(b.getAttribute("data-vid"), 10), quantity: parseInt(b.getAttribute("data-qty"), 10) || 1 };
  var plan = parseInt(b.getAttribute("data-plan"), 10);
  if (plan) line.selling_plan = plan;
  fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [line] }) })
    .then(function () { return window.prenTiersSync ? window.prenTiersSync() : null; })
    .catch(function () {})
    .then(function () { location.reload(); });
});
